import { gql } from "@apollo/client"
import { VENDOR_DETAIL_FRAG } from "./vendor.fragments.gql"

export const VENDOR_LIST = gql`
  query VendorList(
    $query: String
    $departmentId: ID
    $groupName: String
    $status: String
    $first: Int
    $skip: Int
    $filter: UsersByGroupFilterInput
  ) {
    usersByGroup(
      query: $query
      departmentId: $departmentId
      groupName: $groupName
      status: $status
      first: $first
      skip: $skip
      filter: $filter
    ) {
      id
      fullName
      number
      isBlocked
      blockRemark
      status
      statusObj @client {
        id
        name
        intent
      }
      accounts(first: 1, accountType_Codename: "d2f-wallet") {
        id
        balance
        name
        codename
        accountType {
          id
          name
        }
      }
      address {
        id
        village
        address
        district
      }
      groups {
        id
        category {
          id
          codename
        }
        name
      }
      customerId
      createdAt
    }
  }
`

export const VENDOR_DETAIL = gql`
  query VendorDetail($id: Int) {
    userDetails(userId: $id) {
      ...VendorDetailFrag
    }
  }
  ${VENDOR_DETAIL_FRAG}
`

export const VENDOR_MAP_LIST = gql`
  query VendorMapList(
    $query: String
    $departmentId: ID
    $groupName: String
    $status: String
    $first: Int
    $skip: Int
    $filter: UsersByGroupFilterInput
  ) {
    usersByGroup(
      query: $query
      departmentId: $departmentId
      groupName: $groupName
      status: $status
      first: $first
      skip: $skip
      filter: $filter
    ) {
      id
      fullName
      number
      address {
        id
        village
        address
        district
        latitude
        longitude
      }
      status
    }
  }
`

export const VENDORS_SUMMARY = gql`
  query VendorsSummary($latestDays: Int, $filter: SummaryUsersEcomFilterInput) {
    summaryUsersEcom(latestDays: $latestDays, filter: $filter) {
      activeCustomers
      inactiveCustomers
      totalCustomers
      verifiedCustomers
      notVerifiedCustomers
    }
  }
`
export const VENDOR_TRANSACTION_HISTORY = gql`
  query Transactions(
    $filter: TransactionDetailInput
    $skip: Int
    $first: Int
    $query: String
  ) {
    allAccountTransactions(
      first: $first
      skip: $skip
      query: $query
      filter: $filter
    ) {
      id
      date
      account {
        name
        balance
        codename
        id
      }
      status
      amount
      paymentMethod {
        codename
        id
        name
      }
      transactionType {
        id
        name
      }
      referenceId
      remark
      attachments {
        id
        url
      }
    }
  }
`
